import React from "react";
import "../styles/Footer.css";

function Footer() {
  return (
    <footer>
      <div className="footer-container">
        <p id="version">Version: 2.0</p>
        <p id="powered-by">Powered by TVLAB</p>
      </div>
    </footer>
  );
}

export default Footer;
